// extracted by mini-css-extract-plugin
export var avatar = "_ou-3";
export var avatarContainer = "_ou-2";
export var avatarSpacer = "_ou-5";
export var avatarSpacerContainer = "_ou-4";
export var avatarStackContainer = "_ou-1";
export var bubble = "_ou-0";
export var remainderBubble = "_ou-6";